<ng-container [ngSwitch]="column.template">          

    <span *ngSwitchCase="'time'"
        class="text-nowrap">
        {{record[column.name]|date:'yyyy-MM-dd HH:mm:ss.SSS':'UTC'}}
    </span>

    <a *ngSwitchCase="'locationLink'" href="javascript:false;" (click)="showLocationTable($any(record))">{{record[column.name]}}</a>

    <ng-container *ngSwitchCase="'correlationLink'">
    <a *ngIf="record[column.name]" href="javascript:false;" (click)="showCorrelation($any(record))" class="text-nowrap">
        {{record[column.name]|date:'yyyy-MM-dd HH:mm:ss.SSS':'UTC'}}
    </a>
    </ng-container>
  
    <ng-container *ngSwitchDefault>
        {{record[column.name]}}
    </ng-container>

</ng-container>

